module.exports = __webpack_public_path__ + "img/Beta Digitis - Gif 2.f2a0ebe2.gif";